import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { Layout } from "@/components/Layout";

import Home from "@/pages/Home";
import Prestations from "@/pages/Prestations";
import ServiceDetail from "@/pages/ServiceDetail";
import ServicesPartenaires from "@/pages/ServicesPartenaires";
import Galerie from "@/pages/Galerie";
import APropos from "@/pages/APropos";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Devis from "@/pages/Devis";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function Page({ children }) {
  return <Layout>{children}</Layout>;
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-gold">Chargement…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <AuthProvider>
          <ContentProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Page><Home /></Page>} />
                <Route path="/prestations" element={<Page><Prestations /></Page>} />
                <Route path="/musique-live" element={<Page><ServiceDetail /></Page>} />
                <Route path="/dj" element={<Page><ServiceDetail /></Page>} />
                <Route path="/location-materiel" element={<Page><ServiceDetail /></Page>} />
                <Route path="/services-partenaires" element={<Page><ServicesPartenaires /></Page>} />
                <Route path="/galerie" element={<Page><Galerie /></Page>} />
                <Route path="/a-propos" element={<Page><APropos /></Page>} />
                <Route path="/faq" element={<Page><Faq /></Page>} />
                <Route path="/contact" element={<Page><Contact /></Page>} />
                <Route path="/devis" element={<Page><Devis /></Page>} />
                <Route path="/mentions-legales" element={<Page><Legal type="mentions" /></Page>} />
                <Route path="/confidentialite" element={<Page><Legal type="confidentialite" /></Page>} />
                <Route path="/cookies" element={<Page><Legal type="cookies" /></Page>} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </ContentProvider>
        </AuthProvider>
      </ErrorBoundary>
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

export default App;
